// (() => {
//   function findPanelControls(featuredEl) {
//     const panel = featuredEl.closest('.tabs__panel');
//     if (!panel) return null;

//     for (const child of Array.from(panel.children)) {
//       if (child.classList && child.classList.contains('swiper-controls')) return child;
//     }
//     return null;
//   }

//   function bindFeaturedCollection(featuredEl) {
//     const slider = featuredEl.sliderInstance?.slider;
//     if (!slider) return false;

//     const controls = findPanelControls(featuredEl);
//     if (!controls) return false;

//     const nextEl = controls.querySelector('.swiper-button-next');
//     const prevEl = controls.querySelector('.swiper-button-prev');
//     const paginationEl = controls.querySelector('.swiper-pagination');


//     /* ✅ MOVE ONE SLIDE AT A TIME */
//     slider.params.slidesPerGroup = 1;
//     slider.params.slidesPerView = slider.params.slidesPerView || 4;
//     slider.params.loopFillGroupWithBlank = false;


//     // Navigation
//     if (nextEl && prevEl) {
//       slider.params.navigation = slider.params.navigation || {};
//       slider.params.navigation.nextEl = nextEl;
//       slider.params.navigation.prevEl = prevEl;

//       slider.navigation?.destroy?.();
//       slider.navigation?.init?.();
//       slider.navigation?.update?.();
//     }

//     // Pagination
//     if (paginationEl) {
//       slider.params.pagination = slider.params.pagination || {};
//       slider.params.pagination.el = paginationEl;

//       slider.pagination?.destroy?.();
//       slider.pagination?.init?.();
//       slider.pagination?.render?.();
//       slider.pagination?.update?.();
//     }

//     // Force click
//     if (nextEl) {
//       nextEl.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         slider.slideNext();
//       });
//     }

//     if (prevEl) {
//       prevEl.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         slider.slidePrev();
//       });
//     }

//     return true;
//   }

//   function init() {
//     const featuredEls = Array.from(
//       document.querySelectorAll('featured-collection[data-enable-slider="true"]')
//     );

//     featuredEls.forEach((el) => {
//       let tries = 0;
//       const t = setInterval(() => {
//         tries += 1;
//         if (bindFeaturedCollection(el) || tries > 20) clearInterval(t);
//       }, 150);

//       el.addEventListener('tabChange', () => {
//         setTimeout(() => bindFeaturedCollection(el), 0);
//         setTimeout(() => bindFeaturedCollection(el), 200);
//       });
//     });
//   }

//   document.addEventListener('DOMContentLoaded', init);
// })();

(() => {
  function findPanelControls(featuredEl) {
    const panel = featuredEl.closest('.tabs__panel');
    if (!panel) return null;

    for (const child of Array.from(panel.children)) {
      if (child.classList && child.classList.contains('swiper-controls')) return child;
    }
    return null;
  }

  function bindFeaturedCollection(featuredEl) {
    const slider = featuredEl.sliderInstance?.slider;
    if (!slider) return false;

    const controls = findPanelControls(featuredEl);
    if (!controls) return false;

    const nextEl = controls.querySelector('.swiper-button-next');
    const prevEl = controls.querySelector('.swiper-button-prev');
    const paginationEl = controls.querySelector('.swiper-pagination');


    /* ✅ MOVE ONE SLIDE AT A TIME */
    slider.params.slidesPerGroup = 1;
    slider.params.slidesPerView = slider.params.slidesPerView || 4;
    slider.params.loopFillGroupWithBlank = false;


    // Navigation
    if (nextEl && prevEl) {
      slider.params.navigation = slider.params.navigation || {};
      slider.params.navigation.nextEl = nextEl;
      slider.params.navigation.prevEl = prevEl;

      slider.navigation?.destroy?.();
      slider.navigation?.init?.();
      slider.navigation?.update?.();
    }

    // Pagination
    if (paginationEl) {
      slider.params.pagination = slider.params.pagination || {};
      slider.params.pagination.el = paginationEl;

      slider.pagination?.destroy?.();
      slider.pagination?.init?.();
      slider.pagination?.render?.();
      slider.pagination?.update?.();
    }

    // Force click (once per control — tab switches re-call bind without stacking listeners)
    if (nextEl && !nextEl.dataset.fcForceNavBound) {
      nextEl.dataset.fcForceNavBound = 'true';
      nextEl.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        slider.slideNext();
      });
    }

    if (prevEl && !prevEl.dataset.fcForceNavBound) {
      prevEl.dataset.fcForceNavBound = 'true';
      prevEl.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        slider.slidePrev();
      });
    }

    return true;
  }

  function bindFeaturedCollectionsInPanel(panel) {
    if (!panel) return;
    panel.querySelectorAll('featured-collection[data-enable-slider="true"]').forEach((el) => {
      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (bindFeaturedCollection(el) || tries > 20) clearInterval(t);
      }, 150);
      setTimeout(() => bindFeaturedCollection(el), 0);
      setTimeout(() => bindFeaturedCollection(el), 200);
    });
  }

  function init() {
    const featuredEls = Array.from(
      document.querySelectorAll('featured-collection[data-enable-slider="true"]')
    );

    featuredEls.forEach((el) => {
      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (bindFeaturedCollection(el) || tries > 20) clearInterval(t);
      }, 150);
    });

    // tabChange fires on product-tabs host, not on featured-collection; bind sliders in the selected panel
    document.querySelectorAll('[is="product-tabs"]').forEach((tabsHost) => {
      if (tabsHost.dataset.fcSliderTabsBound) return;
      tabsHost.dataset.fcSliderTabsBound = 'true';
      tabsHost.addEventListener('tabChange', (e) => {
        bindFeaturedCollectionsInPanel(e.detail?.selectedTab);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();